import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const Header = ({ siteTitle }) => (
  <header>
  <div class="text-center p-1 col-12"
  style={{
          backgroundRepeat: 'repeat',
          backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
    }}
   >
      <h1> 
      <StaticImage
      src="../images/was.png"
      width={40}
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Toko ONline Whatsapp"
    />  <Link
          to="/" className="text-dark"
        >
          {siteTitle}
        </Link>
      </h1>
      </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
